import { render, staticRenderFns } from "./NavigationTopLangButton.vue?vue&type=template&id=43da0897&"
import script from "./NavigationTopLangButton.vue?vue&type=script&lang=js&"
export * from "./NavigationTopLangButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports